import { BASE_URL } from "@/config";

export const getChallengerData = async (
  fizzAddress: string,
  startingEra: number = -1,
  limit: number = 1
) => {
  if (!fizzAddress) {
    console.error("Missing required parameter: fizzAddress");
    return {
      success: false,
      message: "Missing required parameter: fizzAddress",
    };
  }

  try {
    const response = await fetch(
      `${BASE_URL}/api/challenger?fizzAddress=${fizzAddress}&startingEra=${startingEra}&limit=${limit}`,
      {
        method: "GET",
        cache: "no-store",
      }
    );

    if (!response.ok) {
      return {
        success: false,
        message: "Failed to fetch challenges data",
        status: response.status,
      };
    }

    const responseData = await response.json();

    return responseData;
  } catch (error) {
    console.error("Error fetching challenger data -> ", error);
    return {
      success: false,
      message: "An error occurred while fetching challenges data.",
    };
  }
};
